import PropTypes from 'prop-types'
import MultiClamp from 'react-multi-clamp'

const ThumbTitle = ({ text }) => {
  return (
    <h4 className="thumb-title">
      <MultiClamp ellipsis="..." clamp={2}>
        { text }
      </MultiClamp>
    </h4>
  )
}

ThumbTitle.propTypes = {
  text: PropTypes.string.isRequired
}

export default ThumbTitle
